import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEEnum } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumItem } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumItem';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MDAConstant } from '../../Base/MDAConstant';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';
import { UniqueKeyManager } from '../../../MD/UniqueKeyManager';

export class JointEnumShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointEnumShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_Enum.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEEnum, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.enumItems, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_ENUM;
  }

  get enum(): BEEnum {
    return this.element() as BEEnum;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加枚举项
      case 'shape:addEnumItem':
        element = this.addEnumItem();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof EnumItem) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name} = ${element.itemValue}`;
      } else {
        title = `${element.displayName} = ${element.itemValue}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addEnumItem(): EnumItem {
    const item = MDRepository.createEnumItem(this.enum);
    MDExtendService.setElementListSequence(this.enum.enumItems, true);
    this.model().compartments[0].push(item);
    item.id = UniqueKeyManager.instance.getUniqueKey();
    return item;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.enum.enumItems.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.enum.enumItems.splice(this.enum.enumItems.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(bEEnum: BEEnum, isCollapse = false): ShapeModel {
    const model = new ShapeModel(bEEnum, isCollapse);
    model.addCompartment(bEEnum.enumItems.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointEnumShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEEnum();
    newElement.copyFrom(this.enum, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.enums.push(newElement);
    }

    this.enum.enumItems.forEach(item => {
      const parameter = new EnumItem();
      parameter.copyFrom(item, false);
      MDExtendService.setCreateInfo(parameter);
      parameter.enum_ID = newElement.id;
      newElement.enumItems.push(parameter);
      elements.push(parameter);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): EnumItem | null {
    let newElement: EnumItem | null = null;
    if (element instanceof EnumItem) {
      newElement = new EnumItem();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.enum_ID = this.enum.id;
      this.enum.enumItems.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 枚举
   *    - 名称必须使用Enum开头，E大写
   *    - 必须包含至少一个枚举项
   * 2. 枚举项
   *    - 枚举项的值，建议使用二进制值
   *    - 不能存在同名枚举项
   *    - 不能存在相同值的枚举项
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.enum.designId;
    MDValidation.validateBaseElement(this.enum, this.enum.designId, true, errors);
    if (!this.enum.name.startsWith('Enum')) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `枚举 [${this.enum.name}] 的名称必须使用Enum开头，E大写`));
    }
    if (this.enum.enumItems.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `枚举 [${this.enum.displayName}] 必须包含至少一个枚举项`));
    } else {
      this.enum.enumItems.forEach(element => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if (element.itemValue !== 1 && element.itemValue % 2 > 0) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Warning, containerDesignId, element.designId, `枚举 [${this.enum.displayName}] 的枚举项 [${element.displayName}] 的值，建议使用二进制值`));
        }
        if (this.enum.enumItems.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `枚举 [${this.enum.displayName}] 不能存在同名枚举项 [${element.name}]`));
        }
        if (this.enum.enumItems.find(item => element.designId !== item.designId && element.itemValue === item.itemValue)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `枚举 [${this.enum.displayName}] 不能存在相同值的枚举项 [${element.name}]`));
        }
      });
    }
    return errors;
  }
}
